module.exports = "https://r.zoocdn.com/_next/static/images/opengraph-image-5ca1a0e5b96f4b070f9c1e0858dbcf59.jpg";